import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import ParticleField from './ParticleField';
import SummoningCircle from './SummoningCircle';
import FloatingRunes from './FloatingRunes';

const HeroSectionV2 = ({ onReady }) => {
	useEffect(() => {
		if (onReady) onReady();
	}, [onReady]);

	return (
		<section id="home" className="relative min-h-screen flex items-center bg-ink overflow-hidden">
			<div className="absolute inset-0 z-[1] bg-gradient-to-b from-ink/80 via-ink/60 to-ink pointer-events-none" />
			<div
				className="absolute inset-0 z-[1] opacity-10 pointer-events-none"
				style={{
					backgroundImage: 'radial-gradient(rgba(201,164,74,0.5) 1px, transparent 1px)',
					backgroundSize: '28px 28px',
				}}
			/>
			<SummoningCircle />
			<ParticleField className="absolute inset-0 z-[2]" />
			<FloatingRunes />

			<div className="relative z-10 w-full h-full min-h-screen flex items-center justify-center py-24 px-4 sm:px-6 lg:px-8">
				<motion.div
					initial={{ opacity: 0, y: 24 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.7, ease: 'easeOut' }}
					className="max-w-3xl w-full text-center bg-panel/90 backdrop-blur border border-gold/40 rounded-lg p-8 md:p-12 shadow-[0_0_50px_rgba(201,164,74,0.15)]"
				>
					<div className="font-mono text-xs uppercase tracking-[0.3em] text-rpgblue mb-4">
						Character Sheet
					</div>
					<h1 className="font-display text-4xl md:text-6xl font-semibold mb-4 text-gray-100">
						<span className="text-gold">Sam Togun</span>
					</h1>
					<h2 className="font-mono text-lg md:text-xl mb-6 text-gray-300">
						Class: <span className="text-rpgblue">Senior Backend Engineer &amp; Solutions Architect</span>
					</h2>
					<p className="text-base md:text-lg text-gray-400 mb-10 max-w-2xl mx-auto">
						I architect and build scalable backend systems that power modern applications. With expertise in cloud technologies and microservices, I help businesses achieve reliability and performance at scale.
					</p>
					<div className="flex flex-wrap justify-center gap-4">
						<motion.a
							whileHover={{ scale: 1.05, rotate: -1 }}
							whileTap={{ scale: 0.95 }}
							href="#contact"
							className="px-6 py-3 bg-gold border-2 border-black rounded-md text-ink font-semibold shadow-[0_0_20px_rgba(201,164,74,0.5)] hover:bg-blorange hover:shadow-[0_0_28px_rgba(255,106,26,0.75)] transition-colors"
						>
							⚔ Contact Me
						</motion.a>
						<motion.a
							whileHover={{ scale: 1.05, rotate: 1 }}
							whileTap={{ scale: 0.95 }}
							href="#projects"
							className="px-6 py-3 border-2 border-black bg-panel2 rounded-md text-rpgblue font-medium hover:border-blorange hover:text-blorange transition-colors"
						>
							📜 View Quests
						</motion.a>
						<motion.a
							whileHover={{ scale: 1.05, rotate: -1 }}
							whileTap={{ scale: 0.95 }}
							href="https://drive.google.com/file/d/1O4UxXOZdk4QJonOE6-0Ly0jju9DViJn1/view?usp=sharing"
							download
							className="px-6 py-3 border-2 border-black bg-panel2 rounded-md text-gray-300 font-medium hover:border-blorange hover:text-blorange transition-colors flex items-center gap-2"
						>
							<i className="fas fa-download" aria-hidden="true"></i>
							Download CV
						</motion.a>
					</div>
				</motion.div>
			</div>
		</section>
	);
};

export default HeroSectionV2;
